import { ComponentType } from 'react';
import type { Invoice } from './FarmerInvoice';
import { useQuery } from '@tanstack/react-query';
import { API } from 'network/api';

export interface PaymentNote {
  id: string;
  attachmentUrl: string;
}

export const withPaymentNotes = (
  Component: ComponentType<
    { invoice: Invoice; paymentNotes: PaymentNote[] } & Record<string, unknown>
  >,
) => {
  const EnhancedComponent = ({
    invoice,
    ...props
  }: { invoice: Invoice } & Record<string, unknown>) => {
    const { data } = useQuery({
      queryKey: ['invoice-paymentNote', { invoiceId: invoice?.invoiceId }],
      queryFn: async () =>
        API.get(`/invoices/${invoice?.invoiceId}/payment-notes`),
      select: (res) => res?.data as PaymentNote[],
      enabled: !!invoice?.invoiceId,
      staleTime: 10000,
      retry: false,
    });

    return <Component invoice={invoice} paymentNotes={data || []} {...props} />;
  };

  return EnhancedComponent;
};
